import { FC, useState } from "react";
import { Button, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, TablePagination  } from "@mui/material";

import localisations from "domains/allocations/localisation";
import { ProductWithLedgerManagedStatus } from "domains/products/services/ProductsService";

type ManagedProductsTableProps = {
    data: ProductWithLedgerManagedStatus[];
    hasButton: boolean;
    buttonClick?: (productId: number | null) => Promise<any>;
};

const ManagedProductsTable: FC<ManagedProductsTableProps> = (props) => {
    const { data, hasButton, buttonClick } = props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return (
        <Grid item xs={12}>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>{localisations.addMultipleManagedProducts.productIdHeader}</TableCell>
                            <TableCell>{localisations.addMultipleManagedProducts.productSkuHeader}</TableCell>
                            <TableCell>{localisations.addMultipleManagedProducts.productDescriptionHeader}</TableCell>
                            <TableCell>{localisations.addMultipleManagedProducts.productManagedStatusHeader}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(({productId, sku, isLedgerManaged, description}) => {
                            return (
                                <TableRow key={productId} className={isLedgerManaged != null ? isLedgerManaged === true ? "isLedgerManaged" : "notLedgerManaged" : "notFound"}>
                                    <TableCell>{productId != null && productId > 0 ? productId : ""}</TableCell>
                                    <TableCell>{sku}</TableCell>
                                    <TableCell>{description}</TableCell>
                                    <TableCell align="justify">{isLedgerManaged != null ? isLedgerManaged.toString() : localisations.addMultipleManagedProducts.productNotFound}
                                    </TableCell>
                                    <>
                                        {hasButton && buttonClick !== undefined ? (
                                            <TableCell>
                                                        <Button  data-testid={productId}
                                                            aria-label={localisations.addMultipleManagedProducts.markProductAsManagedButtonText}
                                                            onClick={() => buttonClick(productId)}
                                                            variant="contained">
                                                            {localisations.addMultipleManagedProducts.markProductAsManagedButtonText}
                                                        </Button>

                                            </TableCell>
                                        ) : (<></>)}
                                    </>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, { label: localisations.addMultipleManagedProducts.all, value: data.length }]}
                                colSpan={5}
                                count={data.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                SelectProps={{
                                    inputProps: {
                                        'aria-label': localisations.addMultipleManagedProducts.rowsPerPage,
                                    },
                                    native: true,
                                }}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </Grid>
    );
};

export default ManagedProductsTable;
